import React, { Fragment } from 'react'

export default function CourseCard({title, date, subdate, category, text, link, image, price, icon, iconBackgroundColour}) {

  return (
    <div className="card ">
      <div className="card__image">
        {
          image &&
          <img decoding="async" src={image} alt={title} />
        }
        {
          !image &&
          <div style={{background: 'linear-gradient(72deg, #00A4B7 0%, #eee 100%)', height: '150px'}}></div>
        }
      </div>
      <div className="card__title">
        {title}
      </div>
      <div className="card__icons">
        <div className="card__icon">
          <div className="card__icon__icon color-blue">
            <i className="fas fa-calendar-alt" aria-hidden="true"></i>
          </div>
          <div className=''>
            <div className="card__icon__text" dangerouslySetInnerHTML={{__html: date}}></div>
            {subdate && <div className='text-xs text-gray-500'>{subdate}</div>}
            
          </div>
        </div>
        <div className="card__icon">
          <div className={`card__icon__icon ${iconBackgroundColour}`} >
            <i className={icon} aria-hidden="true"></i>
          </div>
          <div className="card__icon__text">
            {category}
          </div>
        </div>
        <div className="card__icon">
          <div className="card__icon__icon color-yellow">
            <i className="fas fa-pound-sign" aria-hidden="true"></i>
          </div>
          <div className="card__icon__text">
            £{price} <small className="text-[11px]">+VAT</small>
          </div>
        </div>
      </div>
      <div className="card__content">
        {text}
      </div>
      <div className="card__cta">
        <div className="">
          <a href={link}
           target="_self" className="cta">
            Read More
          </a>
        </div>
      </div>
    </div>
  )
}
